import React from 'react'

const Divider = () => {
  return (
    <div style={{padding:".1px", background:"turquoise"}} className="w-100"></div>
  )
}

export default Divider